<template>
  <!-- Main container -->
  <div v-if="isChatOpen" class="chat-box">
    <!-- msg-header section starts -->
    <div class="msg-header">
      <div class="container1">
        <img v-if="activeChat.avatar" :src="`http://localhost:9000/story/${activeChat.avatar.filename}`" class="msgimg" />
        <div class="active">
          <p>{{ activeChat.name }}</p>
        </div>
      </div>
      <div class="container2">
        <div class="active"></div>
        <div class="active">
          <button @click="closeChat">X</button>
        </div>
      </div>
    </div>
    <!-- msg-header section ends -->

    <!-- Chat inbox  -->
    <div class="chat-page">
      <div class="msg-inbox">
        <div class="chats">
          <!-- Message container -->
          <div class="msg-page">
            <template v-for="(message, index) in messages" :key="index">
              <friend-chat-out
                v-if="message.to === activeChat.user_id"
                :message="message"
              ></friend-chat-out>
              <friend-chat-in v-else :message="message" :avatar="activeChat.avatar"></friend-chat-in>
            </template>
          </div>
        </div>

        <!-- msg-bottom section -->
        <div class="msg-bottom">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              :placeholder="placeholder"
              v-model.trim="content"
              @keyup.enter="sendMessage"
            />
            <span class="input-group-text send-icon">
              <i class="bi bi-send"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FriendChatIn from "@/components/FriendChatIn.vue";
import FriendChatOut from "@/components/FriendChatOut.vue";
import { computed, ref, watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    FriendChatIn,
    FriendChatOut,
  },
  props: ["isVisible"],
  setup(props, context) {
    const store = useStore();
    const content = ref("");
    const messages = computed(() => {
      return store.getters["chat/messages"];
    });
    const activeChat = computed(() => {
      return store.getters["chat/activeChat"];
    });
    const placeholder = computed(() => {
      return store.getters["chat/typing"]
        ? "typing message"
        : "write message...";
    });
    const isChatOpen = computed(() => {
      return props.isVisible;
    });
    const closeChat = () => {
      context.emit("closeChat");
    };
    function detectMobileDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      );
    }
    function adjustChatBox() {
      const chatBox = document.querySelector(".chat-box");
      if (!chatBox || detectMobileDevice()) return;
      const computedStyles = window.getComputedStyle(chatBox);
      Object.assign(chatBox.style, {
        top: `calc(100% - ${computedStyles["height"]})`,
        left: `calc(100% - ${computedStyles["width"]})`,
      });
    }
    function startTyping() {
      store.dispatch("chat/startTyping");
    }
    function sendMessage() {
      store.dispatch("chat/sendMessage", content.value);
      content.value = "";
    }
    watch(content, (content) => {
      if (content.length > 0) {
        startTyping();
      }
    });
    onMounted(() => {
      adjustChatBox();
      window.addEventListener("resize", adjustChatBox);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", adjustChatBox);
    });
    return {
      content,
      messages,
      closeChat,
      isChatOpen,
      activeChat,
      placeholder,
      startTyping,
      sendMessage,
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");
* {
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

/* Styling the main container */
.chat-box {
  border-radius: 20px;
  width: 80%;
  max-width: 400px;
  max-height: 90vh; /* Use viewport height for max-height */
  position: fixed;
  top: 37%;
  left: 75%;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

img {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  border-style: none;
  border-radius: 50%;
}
/* Styling the msg-header container */
.msg-header {
  border: 1px solid #ccc;
  width: 100%;
  height: 10%;
  border-bottom: none;
  /* display: inline-block; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #efefef;
  margin: 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
/* Styling the profile picture */
.msgimg {
  margin-left: 2%;
  float: left;
}

.container1 {
  width: 270px;
  height: auto;
  display: flex;
  align-items: center;
}

.container1 p {
  margin: 0;
}

.container2 {
  display: flex;
  justify-content: space-between;
  width: 270px;
  height: auto;
}

.container2 button {
  color: rgb(173, 159, 159);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

/* styling user-name */
.active {
  color: black;
  font-weight: bold;
  margin: 0 0 0 5px;
  height: 10%;
}
/* Styling the inbox */
.chat-page {
  background-color: #ffffff;
  padding: 0;
  border-radius: 0 0 20px 20px;
}

.msg-inbox {
  border: 1px solid #ccc;
  overflow: hidden;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.chats {
  padding: 0 0 0 10px;
}

.msg-page {
  min-height: 500px;
  max-height: 500px;
  overflow-y: auto;
  scrollbar-width: none;
}

.msg-page::-webkit-scrollbar {
  display: none;
}

/* Styling the msg-bottom container */
.msg-bottom {
  border-top: 1px solid #ccc;
  position: relative;
  height: 50px;
  background-color: rgb(239 239 239) !important;
}
/* Styling the input field */
.input-group {
  float: right;
  margin-top: 13px;
  margin-right: 20px;
  outline: none !important;
  border-radius: 20px;
  width: 61% !important;
  background-color: #fff;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.form-control {
  border: none !important;
  border-radius: 20px !important;
  display: block;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input-group-text {
  background: transparent !important;
  border: none !important;
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1.5rem;
  font-weight: b;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  font-weight: bold !important;
  cursor: pointer;
}

input:focus {
  outline: none;
  border: none !important;
  box-shadow: none !important;
}

.send-icon {
  font-weight: bold !important;
}

/* Styling the avatar  */
received-chats-img {
  display: inline-block;
  width: 50px;
  float: left;
}

.received-msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}
.received-msg-inbox {
  width: 57%;
}

.received-msg-inbox p {
  background: #efefef none repeat scroll 0 0;
  border-radius: 10px;
  color: #646464;
  font-size: 14px;
  margin-left: 1rem;
  padding: 1rem;
  width: 100%;
  box-shadow: rgb(0 0 0 / 25%) 0px 5px 5px 2px;
}
p {
  overflow-wrap: break-word;
}

/* Styling the msg-sent time  */
.time {
  color: #777;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}
.outgoing-chats {
  overflow: hidden;
  /* margin: 26px 20px; */
}

.outgoing-chats-msg p {
  background-color: #3a12ff;
  background-image: linear-gradient(
    45deg,
    #ee087f 0%,
    #dd2a7b 25%,
    #9858ac 50%,
    #8134af 75%,
    #515bd4 100%
  );
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  color: #fff;
  padding: 5px 10px 5px 12px;
  width: 100%;
  padding: 1rem;
  box-shadow: rgb(0 0 0 / 25%) 0px 2px 5px 2px;
}
.outgoing-chats-msg {
  float: right;
  width: 46%;
}

/* Styling the avatar */
.outgoing-chats-img {
  display: inline-block;
  width: 50px;
  float: right;
  margin-right: 1rem;
}

@media only screen and (max-device-width: 1024px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .msg-header {
    height: 5%;
  }
  .msg-page {
    max-height: none;
  }
  .received-msg-inbox p {
    font-size: 28px;
  }
  .outgoing-chats-msg p {
    font-size: 28px;
  }
  .msg-page {
    width: 95%;
    max-height: 70vh;
    overflow-y: auto;
  }
  .chat-box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@media only screen and (max-device-width: 850px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .msg-header {
    height: 5%;
  }
  .msg-page {
    max-height: none;
  }
  .received-msg-inbox p {
    font-size: 28px;
  }
  .outgoing-chats-msg p {
    font-size: 28px;
  }
  .msg-page {
    width: 95%;
    max-height: 70vh;
    overflow-y: auto;
  }
  .chat-box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@media only screen and (max-device-width: 450px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .msg-header {
    height: 5%;
  }
  .msg-page {
    max-height: none;
  }
  .received-msg-inbox p {
    font-size: 28px;
  }
  .outgoing-chats-msg p {
    font-size: 28px;
  }
  .msg-page {
    width: 95%;
    max-height: 70vh;
    overflow-y: auto;
  }
  .chat-box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@media only screen and (max-device-width: 768px) {
  .msg-page {
    width: 95%;
    max-height: 70vh;
    overflow-y: auto;
  }
  .chat-box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>